<template>
  <div class="myAwardsContainer">
    <AwardsList />
  </div>
</template>

<script>
import AwardsList from '../components/AwardsList';
import rootStore from '@/store';
import store from '../myAwardsStore';
import { mapActions } from 'vuex';

export default {
  components: { AwardsList },
  beforeDestroy() {
    rootStore.unregisterModule(['app', 'myAwards'], store);
  },
  created() {
    rootStore.registerModule(['app', 'myAwards'], store);
  },
  methods: {
    ...mapActions('app/myAwards', ['getAwardsList'])
  },
  mounted() {
    this.getAwardsList();
  }
};
</script>

<style>
.myAwardsContainer {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding: 24px;
  background-color: #f3f4f5;
}
</style>
